import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { SERVICE_DATA } from "@/data/services";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="section-alt border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-1 mb-6">
              <span><span className="font-heading text-2xl font-bold text-white">VAN</span><span className="font-heading text-2xl font-bold gold-shimmer">SIGN</span></span>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Vancouver's premium signage company. Elevating brands with custom LED displays, channel letters, and comprehensive signage solutions.
            </p>
            <div className="flex gap-4">
              <a href="tel:+17783220801" data-testid="footer-phone" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-gold hover:border-gold/30 transition-all">
                <Phone className="w-4 h-4" />
              </a>
              <a href="mailto:info@vansign.ca" data-testid="footer-email" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-gold hover:border-gold/30 transition-all">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6 text-sm tracking-widest uppercase">Services</h4>
            <ul className="space-y-3">
              {SERVICE_DATA.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="text-sm text-white/50 hover:text-gold transition-colors flex items-center gap-1 group">
                    {s.title}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6 text-sm tracking-widest uppercase">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/portfolio", label: "Portfolio" },
                { to: "/about", label: "About Us" },
                { to: "/contact", label: "Contact" },
                { to: "/booking", label: "Free Consultation" },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-white/50 hover:text-gold transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6 text-sm tracking-widest uppercase">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-gold mt-1 flex-shrink-0" />
                <a href="https://maps.google.com/?q=780+E+Cordova+St,+Vancouver,+BC+V6A+1M3" target="_blank" rel="noopener noreferrer" className="text-sm text-white/50 hover:text-gold transition-colors">780 E Cordova St, Vancouver, BC V6A 1M3</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-gold mt-1 flex-shrink-0" />
                <a href="tel:+17783220801" className="text-sm text-white/50 hover:text-gold transition-colors">(778) 322-0801</a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-gold mt-1 flex-shrink-0" />
                <span className="text-sm text-white/50">Mon - Sun: 4PM - 9PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="gold-line mt-16 mb-8"></div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} VANSIGN. All rights reserved. Vancouver, BC.
          </p>
          <p className="text-xs text-white/30">
            Powered by{" "}
            <a href="https://www.averoan.com" target="_blank" rel="noopener noreferrer" className="text-gold/60 hover:text-gold transition-colors">
              Averoan Technologies Inc.
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
